import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-950 cosmic-bg">
      <ScrollToTop />
      <Header />
      <main className="relative z-10 flex-1 flex flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
